import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Modal, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, rem, VStack } from '@bonusly/design-system';

import { Announcement } from '../types/announcements';
import { AnnouncementCard } from './announcement-card';
import { EmptyState } from './announcements-carousel/empty-state';

const MOBILE_CARD_SHADOW = `0px 0px 1px 0px rgba(0, 0, 0, 0.08),
0px 1px 2px 0px rgba(0, 0, 0, 0.05),
0px 5px 4px 0px rgba(0, 0, 0, 0.04),
0px 11px 5px 0px rgba(0, 0, 0, 0.02),
0px 19px 6px 0px rgba(0, 0, 0, 0.01)`;

interface AnnouncementsMobileModalProps {
	announcements: Announcement[];
	isOpen: boolean;
	onClose: () => void;
}

export const AnnouncementsMobileModal: FC<AnnouncementsMobileModalProps> = ({ announcements, isOpen, onClose }) => {
	const { t } = useTranslation('announcements');
	const hasAnnouncements = announcements.length > 0;

	return (
		<Modal isOpen={isOpen} onClose={onClose} size="full">
			<ModalOverlay />
			<ModalContent bgColor="bg.surface">
				<Box position="fixed" top={0} left={0} right={0} zIndex={2} bgColor="bg.surface" borderBottom="1px solid" borderColor="border.default">
					<ModalHeader px={rem(20)} py={rem(16)}>
						{t('carousel.header')}
					</ModalHeader>
					<ModalCloseButton size="md" borderRadius="full" />
				</Box>
				<Box pt={rem(64)}>
					<VStack spacing={rem(20)} p={rem(20)} minH={hasAnnouncements ? undefined : '60vh'} justifyContent={hasAnnouncements ? undefined : 'center'}>
						{hasAnnouncements ? (
							announcements.map((announcement) => (
								<Box key={announcement.id} width="100%">
									<AnnouncementCard announcement={announcement} boxShadow={MOBILE_CARD_SHADOW} fontSize="sm" />
								</Box>
							))
						) : (
							<EmptyState />
						)}
					</VStack>
				</Box>
			</ModalContent>
		</Modal>
	);
};
